import { Component, OnInit, ViewChild, Input, Inject, Output, EventEmitter, AfterViewInit, ContentChild, TemplateRef } from '@angular/core';
import { MatDialogConfig, MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PanelTypeEditComponent } from './paneltype-edit.component';
import { PanelType } from 'solar-bo';


@Component({
  selector: 'app-paneltype-edit-dlg',
  templateUrl: './paneltype-edit-dlg.component.html'
})
export class PanelTypeEditDlgComponent implements OnInit, AfterViewInit {

  title: string = "Panel Type";
  titlesub: string = "";
  submitted: boolean = false;
  @Output() saveEvent = new EventEmitter<PanelType>();
  @Input() panel: PanelType = new PanelType();
  @ViewChild('editform') editform: PanelTypeEditComponent;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (data != null) {

      this.panel = data.entity2edit;
      this.configUI();
    }
  }

  configUI(){
    if (this.panel==null){
      this.title='<i class="far fa-plus-square"></i> New Panel Type';
      this.titlesub="Please enter minimum data to create a panel";
    }
    else{
      this.title='<i class="far fa-edit"></i> Edit Panel Type';
      this.titlesub="This data is generic for all sites";
    }
  }

  saveModel() {
    this.editform.saveModel();

  }

  isvalid() {
    if (this.editform != null) {//en el inicio no es accesible
      return this.editform.isvalid();
    }
    else {
      return false;
    }

  }

  ngOnInit() {

  }
  ngAfterViewInit() {
    this.editform.saveEvent.subscribe((elemedited) => this.saveModelEvent(elemedited));
  }

  saveModelEvent(elemedited: PanelType) {
    this.saveEvent.emit(elemedited);
    this.submitted = false;
  }

  public static openModal(dialog: MatDialog, entity2edit: PanelType): MatDialogRef<PanelTypeEditDlgComponent> {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = "750px";
    dialogConfig.data = { entity2edit: entity2edit };

    let dialogRef: MatDialogRef<PanelTypeEditDlgComponent>;
    dialogRef = dialog.open(PanelTypeEditDlgComponent, dialogConfig);
    return dialogRef;
  }




}
